export { searchCourse } from './searchCourse';
export { searchAccount } from './searchAccount';
export {
    cleanHistory,
    searchHistory,
    searchRecommendCourse,
    searchHotCourse,
    searchHistoryCourse,
    searchAssociativeWordsCourse,
} from './searchRecommend';
export { viewLog as searchViewLog } from './stat';
